import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="pricing"
export default class extends Controller {
  static targets = ["input", "form"]

  clearErrorsIfEmpty() {
    if (this.inputTarget.value.length === 0) {
      // Error state is determined server-side
      this.formTarget.requestSubmit()
    }
  }

  update() {
    // Dispatch an event to inform other controllers that we
    // refreshed the pricing.
    this.dispatch("refresh", {
      detail: { coupon_code: this.inputTarget.value }
    });

    const pricingFrame = document.querySelector("turbo-frame#pricing")

    // Add coupon code parameter to the URL
    const url = new URL(pricingFrame.getAttribute("src"))
    url.searchParams.set("coupon_code", this.inputTarget.value)
    pricingFrame.setAttribute("src", url.toString())
    pricingFrame.reload()
  }
}
